import { render } from "./UCAcordeon.vue?vue&type=template&id=444126f8"
import script from "./UCAcordeon.vue?vue&type=script&lang=js"
export * from "./UCAcordeon.vue?vue&type=script&lang=js"

import "./UCAcordeon.vue?vue&type=style&index=0&id=444126f8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__